import { Link } from 'react-router-dom';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useAuth } from '../contexts/AuthContext';
import { useTranslations } from '../hooks/useTranslations';

function PromotionBanner() {
  const { data: userData } = useAuth();
  const { t } = useTranslations();

  // Отладочный вывод
  console.log('PromotionBanner - userData:', userData);
  console.log('PromotionBanner - promotion:', userData?.promotion);

  // Показываем баннер только если у пользователя активна промо-скидка
  if (!userData || !userData.promotion) {
    return null;
  }

  return (
    <Link
      to="/activate"
      className="bg-gradient-to-r from-primary to-[#277B6F] text-white py-2 px-4 relative w-full z-10 block hover:opacity-95 transition-opacity cursor-pointer"
    >
      <div className="max-w-7xl mx-auto flex items-center justify-between flex-wrap gap-2">
        <div className="flex items-center space-x-3 flex-1 min-w-[200px]">
          <div className="flex-shrink-0">
            <span className="text-lg font-bold">🎉</span>
          </div>
          <div className="flex-1">
            <p className="text-xs md:text-base font-medium">
              {t('promotionBanner.message')}
            </p>
          </div>
        </div>
        {/* Кнопка на десктопе */}
        <div className="ml-4 px-4 py-2 bg-white text-primary rounded-lg font-semibold text-sm hover:bg-gray-100 transition-colors whitespace-nowrap hidden md:block">
          {t('promotionBanner.viewCourses')}
        </div>
        {/* Стрелка на мобилке */}
        <div className="ml-4 flex-shrink-0 md:hidden">
          <ArrowRightIcon className="h-5 w-5 text-white" />
        </div>
      </div>
    </Link>
  );
}

export default PromotionBanner;

